// THE QUIET LINK TO THE CREDIT PAGE in the builder's composer lines
// (pages/add-app.js): the balance line's "Usage & billing" and the estimate
// line's admin way out ("Add credits to keep going.", functions/
// addAppEstimate.js). One look for both — the line's own caption ink,
// underlined, the title ink under the pointer and on press — and one address,
// the page's own route. The words are the caller's.
export const BuildCreditLink = {
  extends: 'Link',
  href: '/admin/usage',
  color: 'caption',
  textDecoration: 'underline',
  ':hover': { color: 'title' },
  ':active': { color: 'title' }
}
